module.exports = __webpack_public_path__ + "img/banner_tjx_qgjc.b4a5bf37.jpg";